import React, {useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Review from './Review/Review';

const Reviews = ({ food }) => {

    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        fetch(`https://salma-kitchen-server.vercel.app/food/reviews/${food._id}`)
            .then(res => res.json())
            .then(data => setReviews(data));
    }, [food._id]);
    return (
        <div>
            {
                reviews.map(review => <Review key={review._id} review={review} ></Review>)
            }
            <div className='text-center'>
                <Link to={`/post/review/${food._id}`}><button className='btn btn-wide'>Leave a Review</button></Link>
            </div>

        </div>
    );
};

export default Reviews;